import { motion, useInView } from "framer-motion";
import { useRef } from "react";

const SectionDivider = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });

  return (
    <div ref={ref} className="relative py-2 overflow-hidden">
      <motion.div
        className="h-px w-full"
        style={{
          background: "linear-gradient(90deg, transparent, #3b82f6, #06b6d4, transparent)"
        }}
        initial={{ scaleX: 0, opacity: 0 }}
        animate={isInView ? { scaleX: 1, opacity: 1 } : {}}
        transition={{ duration: 1.5, ease: "easeInOut" }}
      />
      <motion.div
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-2 h-2 bg-[#3b82f6] rounded-full"
        initial={{ scale: 0 }}
        animate={isInView ? { scale: [0, 1.5, 1] } : {}}
        transition={{ delay: 0.8, duration: 0.5 }}
      >
        <motion.div
          className="absolute inset-0 bg-[#3b82f6] rounded-full"
          animate={{ scale: [1, 3, 1], opacity: [0.5, 0, 0.5] }}
          transition={{ duration: 2, repeat: Infinity }}
        />
      </motion.div>
    </div>
  );
};

export default SectionDivider;
